import React, {Fragment} from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './PasswordInput.styles';


export default (props)=>{
    let { styles: customStyles, placeholder, show, input } = props;
    customStyles = customStyles || {};
    let e;
    if(show === "true"){
      e = (<input
        type="text"
        className={css(styles.base, customStyles.input)}
        placeholder={placeholder || I18n.t('input.password')}
        autoFocus
        value={props.value}
        {...input}
      />)
    }else{
      e = (<input
        type="password"
        className={css(styles.base, customStyles.input)}
        placeholder={placeholder || I18n.t('input.password')}
        autoFocus
        value={props.value}
        {...input}
      />)
    }
    return (<Fragment>{e}</Fragment>)
  }


// WEBPACK FOOTER //
// ./src/components/inputs/password/PasswordShowInput.js